var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mo-ad1"},[_c('p',{staticStyle:{"margin":"0px","color":"rgb(255, 255, 255)","font-size":"10px","text-align":"center"}},[_vm._v(" Advertisement")]),_c('div')])
}]

export { render, staticRenderFns }